import { render, staticRenderFns } from "./signature.vue?vue&type=template&id=79fbd3e3&scoped=true&"
import script from "./signature.vue?vue&type=script&lang=js&"
export * from "./signature.vue?vue&type=script&lang=js&"
import style0 from "./signature.vue?vue&type=style&index=0&id=79fbd3e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fbd3e3",
  null
  
)

export default component.exports